
export const weekDays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
];

export const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
];

export const getWeekNumber = (d  : Date) => {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((((d as any) - (yearStart as any)) / 86400000) + 1) / 7);
    // Return array of year and week number
    return weekNo;
};

export const getDayOfWeek = (date: Date) => {
    const index = date.getDay();
    if (index === 0) return 6;
    return index - 1;
};

export const dateToString = (date: Date) => {
    const d = new Date(date)
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${month}-${day}`;
};

export const copyDate = (date: Date) => {
    return new Date(dateToString(date));
};

export const copyDates = (dates: Date[]) => {
    return dates.map(d => copyDate(d));
};
